import { useState, useEffect } from 'react';
import { Sidebar } from './components/Sidebar';
import { FlowViewer } from './components/FlowViewer';
import { YAMLUploader } from './components/YAMLUploader';
import { SettingsModal } from './components/SettingsModal';
import { initialFlows } from './data/flowsData';
import { FlowDefinition } from './types';
import './App.css';

function App() {
  const [flows, setFlows] = useState<FlowDefinition[]>(initialFlows);
  const [activeFlowId, setActiveFlowId] = useState<string>(initialFlows[0]?.id || '');
  const [showUploader, setShowUploader] = useState(false);
  const [apiKey, setApiKey] = useState<string>('');
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem('gemini_api_key');
    if (stored) setApiKey(stored);
  }, []);

  useEffect(() => {
    if (apiKey) {
      sessionStorage.setItem('gemini_api_key', apiKey);
    }
  }, [apiKey]);

  const activeFlow = flows.find(f => f.id === activeFlowId);

  const handleFlowAdded = (newFlow: FlowDefinition) => {
    setFlows(prev => [...prev, newFlow]);
    setActiveFlowId(newFlow.id);
    setShowUploader(false);
  };

  return (
    <div className="app">
      <Sidebar 
        flows={flows} 
        activeFlowId={activeFlowId} 
        onFlowSelect={setActiveFlowId} 
      />
      
      {activeFlow && <FlowViewer flow={activeFlow} />}
      
      <button 
        className="settings-fab" 
        onClick={() => setIsSettingsOpen(true)}
        title="Settings"
      >
        <i className="fa-solid fa-gear"></i>
      </button>

      <button 
        className="fab" 
        onClick={() => setShowUploader(!showUploader)}
        title="Upload YAML"
      >
        <i className="fa-solid fa-plus"></i>
      </button>

      {showUploader && (
        <div className="modal-overlay" onClick={() => setShowUploader(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowUploader(false)}>
              <i className="fa-solid fa-xmark"></i>
            </button>
            <h2>Upload YAML Files</h2>
            <YAMLUploader onFlowAdded={handleFlowAdded} apiKey={apiKey} />
          </div>
        </div>
      )}

      <SettingsModal 
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        apiKey={apiKey}
        setApiKey={setApiKey}
      />
    </div>
  );
}

export default App;
